<template>
	<type-wrapper class="type-R" limit :bgUrl="showData.image" v-if="mdContent">
		<!-- <type-content large :style="contentColor" v-if="mdContent"></type-content> -->
		<markdown-it-vue-light :content="mdContent"></markdown-it-vue-light>
	</type-wrapper>
</template>

<script>
	import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js'
	import 'markdown-it-vue/dist/markdown-it-vue-light.css'
	// markdown文本
	import mixin from '../mixin.js'
	export default {
		name: 'type-R',
		mixins: [ mixin ],
		methods: {
			isMarkDown(imageText = '') {
				// 第一行以<!-- Markdown -->开头
				return /^<!-- Markdown -->\s*/.test(imageText);
			},
			toMarkDown(imageText = '') {
				// 去除第一行以<!-- Markdown -->开头
				return imageText.replace(/^<!-- Markdown -->\s*/, '');
			}
		},
		computed: {
			mdContent() {
				if (this.showData.tuwen_content && this.isMarkDown(this.showData.tuwen_content)) {
					return this.toMarkDown(this.showData.tuwen_content) || '';
				}
				return '';
			}
		},
		components: {
			'markdown-it-vue-light': MarkdownItVueLight
		}
	}
</script>

<style scoped lang="less">
	.type-R{}
</style>